import tansel from "../assets/partners/tansel.png";
import emin from "../assets/partners/emin.png";
import ulaş from "../assets/partners/ulaş.png";
import fırat from "../assets/partners/fırat.png";

export const HERO_CONTENT = `This project involves developing a web extension that helps users find the best possible vehicle listings on the popular marketplace site, Sahibinden. The extension will be designed to scrape data from the site and analyze the available vehicle options based on three key criteria: the lowest damage, minimal usage (mileage), and the most affordable price. By using a custom algorithm, the tool will sort and rank vehicles that match the user's preferences, making it easier for them to find the best deals without having to manually search through multiple listings.`;
export const ABOUT_TEXT = `Our project aims to provide an innovative solution that anonymizes football match video content by converting it from 3D to 2D. Currently, football broadcasters and some sports programs are unable to display football videos for analysis on television or the internet due to copyright issues. Our project seeks to overcome this obstacle by anonymizing football match videos and making them usable for analysis.

In our project, we will use artificial intelligence and image processing technologies to convert football match footage from a 3D format into 2D. Through this conversion, copyrighted elements in the video will be anonymized, ensuring that these videos can be used without the risk of copyright infringement. This allows football enthusiasts and program producers to perform their analyses freely without being hindered by copyright restrictions.

The primary goal of our project is to enable the legal use of football content without facing restrictions while also offering an innovative solution in the field of artificial intelligence and image processing.`;

export const PARTNERS = [
  {
    title: "Supervisor",
    image: fırat,
    description: "Dr. Fırat Akba",
  },

  {
    title: "Jury",
    image: tansel,
    description: "Prof. Dr. Tansel Dökeroğlu",
  },
  {
    title: "Jury",
    image: ulaş,
    description: "Dr. Öğr. Üyesi Ulaş Güleç",
  },
  {
    title: "Jury",
    image: emin,
    description: "Dr. Öğr. Üyesi Emin Kuğu",
  },
];

export const CONTACT = {
  address: "Adress",
  phoneNo: "Phone",
  email: "email",
};
